<a [routerLink]="materia.url" title="{{ materia.legalMatter }}">
    <div class="materia-box" [style]="{ 'border-left-color': '#' + materia.color }">
        <p>{{ 'home.catalog_of' | translate }}</p>
        <h3>{{ materia.legalMatter }}</h3>
    </div>
</a>
